<template>
  <section class="blog-details-area ptb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12">
          <div class="blog-details">
            <div class="article-image">
              <img :src="post.image" alt="image" />
            </div>

            <div class="article-content">
              <div class="entry-meta">
                <ul>
                  <li>
                    <span>Posted On:</span>
                    <a href="single-blog.html#">{{post.date}}</a>
                  </li>
                  <li>
                    <span>Posted By:</span>
                    <a href="single-blog.html#">{{post.author}}</a>
                  </li>
                </ul>
              </div>

              <h3>{{post.title}}</h3>
              <div>{{post.body}}</div>
            </div>

            <div class="article-footer">
              <div class="article-tags">
                <span>
                  <i class="fas fa-bookmark"></i>
                </span>

                <a href="single-blog.html#">Fashion</a>,
                <a href="single-blog.html#">Games</a>,
                <a href="single-blog.html#">Travel</a>
              </div>

              <div class="article-share">
                <ul class="social">
                  <li>
                    <a href="single-blog.html#" target="_blank">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="single-blog.html#" target="_blank">
                      <i class="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="single-blog.html#" target="_blank">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a href="single-blog.html#" target="_blank">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-12">
          <aside class="widget-area" id="secondary">
            <section class="widget widget_luvion_posts_thumb">
              <h3 class="widget-title">Popular Posts</h3>

              <template v-for="single in posts">
                <article class="item" :key="single.id" >
                  <a
                  
                  v-on:click="loadPage(single.id)"
                  :href="'#/blog/'+single.id"
                  
                  class="thumb"
                  >
                    <img :src="single.image" class="cover"/>
                    <!-- <span class="fullimage cover bg1" role="img"></span> -->
                  </a>
                  <div class="info">
                    <time datetime="2019-06-30">{{single.date}}</time>
                    <h4 class="title usmall">
                      <a

                       v-on:click="loadPage(single.id)"
                       :href="'#/blog/'+single.id"
                      >{{single.title}}</a>
                    </h4>
                  </div>

                  <div class="clear"></div>
                </article>
              </template>

            </section>
          </aside>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      post: null,
      posts: null
    };
  },
  methods: {
    loadPage(id) {
       this.post = this.posts.filter(post => {
           return post.id == id;
         })[0];
    }
  },
  mounted() {
    this.posts = this.$store.getters.getPost;
    this.post = this.posts.filter(post => {
       return post.id == this.$route.params.id;
    })[0];
  },
  
};
</script>